import React from 'react'
import BentoboxGrid from '../bentobox-grid'

const TypeOneOutside = (props) => <BentoboxGrid {...props} inside={false} featured={false} />

export default TypeOneOutside
